import { render, staticRenderFns } from "./PedigreeOrdersList.vue?vue&type=template&id=0366aa8f"
import script from "./PedigreeOrdersList.vue?vue&type=script&lang=ts"
export * from "./PedigreeOrdersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports